/**
 * parentChildAdapter — comptes de famille (redux `authTokens.storedTokens`) → `UIParentChild`.
 *
 * Le legacy construit cette liste dans `ParentMainLayout.js:86-136` (`groupAccountsByFamily`, puis
 * filtre sur le rôle `student`) et la passe au header ; on ne refait pas ce calcul, on ne fait que
 * remettre en forme ce qu'il donne. Une ligne sans `userId` est écartée : sans identité, la chip ne
 * saurait ni se distinguer ni se sélectionner.
 */
import { type UIParentChild } from "../../../ui/types"

/** Forme lâche : le compte vient d'un réducteur en JS, tous les champs sont optionnels. */
type ApiFamilyAccount = {
    userId?: string | number
    firstname?: string
    avatar?: string
}

export function toUIParentChildren(accounts: ApiFamilyAccount[] | null | undefined): UIParentChild[] {
    return (accounts ?? [])
        .map((account): UIParentChild | null =>
            account?.userId == null
                ? null
                : {
                      id: account.userId,
                      firstname: account.firstname ?? "",
                      avatarUrl: account.avatar,
                  }
        )
        .filter((child): child is UIParentChild => child != null)
}
